import { Loader } from "./style";

const CircularLoading = ({ size = "30px", color = "#fff" }) => (
  <Loader size={size} color={color} />
);

export default CircularLoading;
